import React from 'react'
import styled from 'styled-components'

const StyledUserAvatar = styled.div`
  font-size: 16px;
  height: 100%;
  display: flex;
  align-items: center;
  margin: 0 10px;
  position: relative;

  .ant-avatar {
    margin-right: 20px;
  }

  .avatar-group {
    display: flex;
    flex-direction: column;

    .username {
      vertical-align: middle;
    }

    .time {
      font-size: 12px;
      margin-bottom: -20px;
      text-align: center;
    }
  }
`

interface IUserAvatar {
  src?: string
  name: string
  time: string
}
export const UserAvatar: React.FC<IUserAvatar> = ({ src, name, time }) => {
  // const avatar = AvatarEnum[Number(src)]
  return (
    <StyledUserAvatar>
      <div className="avatar-group">
        <div>
          {/* <Avatar size="large" src={avatar || DefaultAvatar} /> */}
          <span className="username">Hello, {name}</span>
        </div>
        {/* <span className="time">Last Logon: {time}</span> */}
      </div>
    </StyledUserAvatar>
  )
}
